import { ComponentPropsWithRef } from "react";
import { semanticAmber, shade0 } from "../../../../styles/tokens";

export const AttentionIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={semanticAmber} />
    <path
      d="M21.4012 12C22.5559 10 25.4427 10 26.5974 12L36.9897 30C38.1444 32 36.701 34.5 34.3916 34.5H13.607C11.2976 34.5 9.85424 32 11.0089 30L21.4012 12Z"
      fill={shade0}
    />
    <rect
      x="22.5"
      y="16.5"
      width="3"
      height="9"
      rx="1.5"
      fill={semanticAmber}
    />
    <rect x="22.5" y="27" width="3" height="3" rx="1.5" fill={semanticAmber} />
  </svg>
);
